(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbrush-announcement"] && !Shopify.designMode) return;
  try {
    
function announcementRepeatCount(width,groupWidth){
 if(!Number.isFinite(width)||!Number.isFinite(groupWidth)||width<=0||groupWidth<=0)return 0;
 return Math.max(2,Math.ceil(width/groupWidth)+1);
}
class TopbrushAnnouncement extends HTMLElement{
 connectedCallback(){
  this.observer?.disconnect();this.observer=new ResizeObserver(()=>this.fill());this.observer.observe(this);const first=this.querySelector('.tb-announcement__group');if(first)this.observer.observe(first);this.frame=requestAnimationFrame(()=>this.fill());
 }
 disconnectedCallback(){this.observer?.disconnect();cancelAnimationFrame(this.frame);}
 fill(){
  if(!this.isConnected||!this.classList.contains('tb-announcement--scroll')||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const track=this.querySelector('.tb-announcement__track'),first=track?.firstElementChild;if(!first)return;
  const pitch=first.getBoundingClientRect().width,count=announcementRepeatCount(this.clientWidth,pitch);if(!count)return;
  this.style.setProperty('--tb-announcement-shift',-pitch+'px');
  if(track.children.length===count)return;
  const fragment=document.createDocumentFragment();fragment.append(first);
  for(let i=1;i<count;i++){const copy=first.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.querySelectorAll('a').forEach(a=>a.tabIndex=-1);copy.querySelectorAll('[data-shopify-editor-block]').forEach(e=>e.removeAttribute('data-shopify-editor-block'));fragment.append(copy);}
  track.replaceChildren(fragment);
 }
}
if(!customElements.get('topbrush-announcement'))customElements.define('topbrush-announcement',TopbrushAnnouncement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbrush-video-benefits"] && !Shopify.designMode) return;
  try {
    
class TopbrushProductVideo extends HTMLElement {
 connectedCallback(){if(this.bound)return;this.bound=true;this.querySelector('button').addEventListener('click',()=>{const fragment=this.querySelector('template').content.cloneNode(true);const video=fragment.querySelector('video,iframe');this.querySelector('button').replaceWith(fragment);video.focus();if(video.tagName==='VIDEO')video.play().catch(()=>{});},{once:true});}
}
if(!customElements.get('topbrush-product-video'))customElements.define('topbrush-product-video',TopbrushProductVideo);

  } catch(e) { console.error(e); }
})();
})();
